@if (shouldShowLineSwitcher) {
    <button
        ds-button-icon
        kind="tertiary"
        variant="flat"
        size="small"
        class="line-switcher-button"
        [disabled]="isDisabled"
        [ngClass]="{ 'line-switcher-button-fixed-height': !inEditBet }"
        (click)="onClick($event)">
        <vn-icon class="line-switcher-icon" name="sports-swap" [size]="iconSize"></vn-icon>
    </button>
}
